export default __webpack_public_path__ + "static/media/newton_logo.586954e9.svg";